<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="350"
  >
    <v-card>
      <v-container>
        <v-card-title>{{title+' ('+$t('officer_config.delete')+')'}}</v-card-title>
        <v-card-text>{{$t('officer_config.delete')+text}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            dark
            @click="deleteFunction()"
          >
            {{ $t("officer_config.confirm") }}</v-btn>
          <v-btn
            color="error"
            dark
            @click="show = false"
          >{{
              $t("officer_config.cancel")
            }}</v-btn>
        </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    deleteFunction: Function,
    text: String,
    title: String,
    value: Boolean,
  },
  name: "ConfigDeleteDialog",
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>
